// extracted by mini-css-extract-plugin
module.exports = {"xboost":"xbooost_xboost__miKiu"};